var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8398 2.11035C7.31684 2.11035 2.83984 6.58735 2.83984 12.1104C2.83984 17.1014 6.49684 21.2384 11.2778 21.9894V15.0004H8.73784V12.1104H11.2778V9.90735C11.2778 7.40135 12.7698 6.01735 15.0548 6.01735C16.1488 6.01735 17.2928 6.21235 17.2928 6.21235V8.67235H16.0328C14.7898 8.67235 14.4028 9.44335 14.4028 10.2344V12.1104H17.1758L16.7328 15.0004H14.4028V21.9894C19.1828 21.2394 22.8398 17.1004 22.8398 12.1104C22.8398 6.58735 18.3628 2.11035 12.8398 2.11035Z",
    fill: "#173963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.c37fda636fc7f767ded4c4f8e0958b87.svg";
export { ForwardRef as ReactComponent };